
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import myTheme from './theme';
import Container from './components/Container.js';
import { OldLogo, NewLogo, NewLogoSquare } from './components/Logo.js';
import { Github, Instagram, Website } from './components/Images.js';
import ogImage from './assets/og-image.png';
export const theme = myTheme;
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Head = makeShortcode("Head");
const layoutProps = {
  theme
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Head mdxType="Head">
  <meta name="og:image" content={`https://deck-introduction.netlify.app/${ogImage}`} />
  <title>Perkenalan RPL Skandakra Dev</title>
  <link rel="icon" href="https://rpl-skandakra.vercel.app/logo.png" />
    </Head>
    <Container mdxType="Container">
      <div>
        <h1>{`Perkenalan RPL Skandakra Dev`}</h1>
        <NewLogo mdxType="NewLogo" />
      </div>
    </Container>
    <hr></hr>
    <Container mdxType="Container">
      <div>
        <h1>{`Awal Mula`}</h1>
        <p>{`Komunitas ini awalnya berdiri dengan nama `}<strong parentName="p">{`Skanda Code Erpl Community (SCEC)`}</strong>{` pada tanggal
18 November 2019.`}</p>
        <OldLogo mdxType="OldLogo" />
      </div>
    </Container>
    <hr></hr>
    <Container mdxType="Container">
  Setelah sekian lama tidak aktif ... <br />⌛
    </Container>
    <hr></hr>
    <Container mdxType="Container">
      <div>
        <h1>{`Ide Baru`}</h1>
        <p>{`Ide dimulainya kembali komunitas ini muncul saat server discord mulai sepi,
awalnya server ini dibuat oleh 3 orang. Lalu, diisi oleh mayoritas dari kelas
RPL A 2020/2021.`}</p>
        <p>{`Daripada sepi, kita coba bikin jadi komunitas untuk warga RPL di SMK Negeri 2 Karanganyar.`}</p>
      </div>
    </Container>
    <hr></hr>
    <Container mdxType="Container">
      <div>
        <h1>{`Nama Baru`}</h1>
        <p>{`Akhirnya jadilah `}<strong parentName="p">{`RPL Skandakra Dev`}</strong>{` sebagai nama komunitas yang baru. Dengan server
discord yang akan menjadi tempat diskusi kita.`}</p>
      </div>
    </Container>
    <hr></hr>
    <Container mdxType="Container">
      <div>
        <h1>{`Website`}</h1>
        <Website mdxType="Website" />
      </div>
    </Container>
    <hr></hr>
    <Container mdxType="Container">
      <div>
        <h1>{`GitHub`}</h1>
        <Github mdxType="Github" />
      </div>
    </Container>
    <hr></hr>
    <Container mdxType="Container">
      <div>
        <h1>{`Instagram`}</h1>
        <Instagram mdxType="Instagram" />
      </div>
    </Container>
    <hr></hr>
    <Container mdxType="Container">
      <div>
        <h1>{`Terima Kasih`}</h1>
        <NewLogoSquare mdxType="NewLogoSquare" />
      </div>
    </Container>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;